import { useLingui } from '@lingui/react';
import NextLink, { LinkProps } from 'next/link';
import React, { forwardRef } from 'react';
import { UIComponent } from '../..';
import { Element } from '../../atoms';

const InternalLink: UIComponent<LinkProps & { disablePrefix?: boolean } & React.PropsWithChildren> = forwardRef(
  ({ href, as = NextLink, disablePrefix, ...props }, ref: any) => {
    const { i18n } = useLingui();
    const Component = as as unknown as any;
    let prefix = '';
    if (!disablePrefix) {
      prefix = (href || '').startsWith(`/${i18n.locale}`) ? '' : `/${i18n.locale}`;
    }

    return (
      <Element
        as={Component}
        {...props}
        href={href ? `${prefix}${href}` : undefined}
        ref={ref}
        {...(Component === NextLink && { prefetch: false })}
      />
    );
  },
);

export default InternalLink;
